export function isMobile() {
	return window.matchMedia('(max-width: 1200px)').matches;
}

export function setCookie(cName, cValue, expDays) {
	let date = new Date();
	date.setTime(date.getTime() + expDays * 24 * 60 * 60 * 1000);
	const expires = 'expires=' + date.toUTCString();
	document.cookie = cName + '=' + cValue + '; ' + expires + '; path=/';
}

export function getCookie(cName) {
	const name = cName + '=';
	const cDecoded = decodeURIComponent(document.cookie); //to be careful
	const cArr = cDecoded.split('; ');
	let res;
	cArr.forEach((val) => {
		if (val.indexOf(name) === 0) res = val.substring(name.length);
	});
	return res;
}

export function initializeButtonEffect() {
    const buttons = document.querySelectorAll(
        '.c-scroll-down .c-button, [class*="swiper-button"], [class*="c-button-o"], [class*="c-button-s"], .dropdown-menu a, .b-listing figure a, .b-related figure a, .popup-prev, .popup-next, .cf7mls_next, .cf7mls_back, .wpcf7-submit'
    );

    // Helper function to update span position
    function updateSpanPosition(e, button, span) {
        const rect = button.getBoundingClientRect();
        const offsetX = e.clientX - rect.left;
        const offsetY = e.clientY - rect.top;

        span.style.left = `${offsetX}px`;
        span.style.top = `${offsetY}px`;
    }

    buttons.forEach(button => {
        const span = button.querySelector('.fill');
        if (!span) {
            console.warn('No span found in', button);
            return;
        }

        // Calculate button dimensions
        const buttonWidth = button.offsetWidth;
        const buttonHeight = button.offsetHeight;

        // Define a base width for 150ms transition (e.g., 65px)
        const baseWidth = 100;
        const baseDuration = 150; // milliseconds

        // Set a factor to prevent excessively fast or slow transitions
        const scaleFactor = 2; // Adjust this factor as needed

        // Calculate transition duration proportional to the average of width and height
        const averageSize = (buttonWidth + buttonHeight) / 2;
        const transitionDuration = Math.min(
            Math.max((averageSize / baseWidth) * baseDuration, 100), // Set a minimum duration of 100ms
            500 // Set a maximum duration of 500ms
        );

        // Apply the calculated transition duration
        span.style.transitionDuration = `${transitionDuration}ms`;

        // Update span position and size on mouse enter
        button.addEventListener('mouseenter', function(e) {
            updateSpanPosition(e, button, span);
            span.style.width = '0';
            span.style.height = '0';

            // Trigger a reflow
            span.offsetHeight;

            // Expand the span to cover the button
            span.style.width = `${averageSize * scaleFactor}px`;
            span.style.height = `${averageSize * scaleFactor}px`;
        });

        // Update span position on mouse move
        button.addEventListener('mousemove', function(e) {
            updateSpanPosition(e, button, span);
        });

        // Update span size and position on mouse leave
        button.addEventListener('mouseleave', function(e) {
            updateSpanPosition(e, button, span);
            span.style.width = '0';
            span.style.height = '0';
        });
    });
}

// initializeButtonEffect();


//
// Lazyload videos
//
export function lazyLoadVideos() {
    // Get all the images with the "data-src" attribute
    const images = document.querySelectorAll('video.lazy-video');
    const config = {
        rootMargin: `0px 0px ${distanceBelowViewport}px 0px`,
        // threshold: 0 // Adjust the threshold as needed
    };

    // Create a new Intersection Observer
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const video = entry.target;
                // Check if the video has the autoplay attribute
                const shouldAutoplay = video.hasAttribute('autoplay');
                for (var source in video.children) {
                    var videoSource = video.children[source];
                    if (
                        typeof videoSource.tagName === 'string' &&
                        videoSource.tagName === 'SOURCE'
                    ) {
                        videoSource.src = videoSource.dataset.src;
                        videoSource.removeAttribute('data-src');
                    }
                    // Specify the distance below the viewport to load the images (in pixels)
                    const distanceBelowViewport = window.innerHeight * 0.5;

                    // Configure the Intersection Observer
                }
                video.load();
                // Only play the video if it has autoplay attribute
                if (shouldAutoplay) {
                    video.play();
                }
                video.classList.remove('lazy-video');

                // Stop observing the current video
                observer.unobserve(video);
            }
        });
    }, config);

    // Start observing each image
    images.forEach((image) => {
        observer.observe(image);
    });
}
// document.addEventListener("DOMContentLoaded", lazyLoadVideos);
// window.addEventListener('load', lazyLoadVideos);

//
// Lazy load images
//
export function lazyLoadImages() {
    // Get all the images with the "data-src" attribute
    const images = document.querySelectorAll('img[data-src]');

    // Specify the distance below the viewport to load the images (in pixels)
    const distanceBelowViewport = window.innerHeight * 0.5;

    // Configure the Intersection Observer
    const config = {
        rootMargin: `0px 0px ${distanceBelowViewport}px 0px`,
        // threshold: 0 // Adjust the threshold as needed
    };

    // Create a new Intersection Observer
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const image = entry.target;

                // Set the "src" attribute with the value from "data-src"
                image.src = image.dataset.src;
                image.removeAttribute('data-src');

                // Animate the opacity of the image
                image.style.transition = 'all 0.15s';
                image.style.opacity = '0';
                image.onload = () => {
                    image.style.opacity = '1';
                    image.classList.add('lazy-loaded');
                };

                // Stop observing the current image
                observer.unobserve(image);
            }
        });
    }, config);

    // Start observing each image
    images.forEach((image) => {
        observer.observe(image);
    });
}
